// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5294":"b37d4fb6","8328":"e096fe10"}[chunkId] + ".chunk.css";
};